var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 3.16238L6.54589 7.5807C6.54589 7.86029 6.7075 8.00008 7.03074 8.00008H8.97013C9.29336 8.00008 9.45498 7.86029 9.45498 7.5807L9.77821 3.16238C9.77821 3.00988 9.72434 2.8955 9.6166 2.81925C9.53579 2.71758 9.42804 2.66675 9.29336 2.66675H6.70751C6.57282 2.66675 6.45161 2.71758 6.34387 2.81925C6.26306 2.8955 6.22266 3.00988 6.22266 3.16238Z",
    fill: "#EC6655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00043 9.77832C8.48997 9.77832 8.9022 9.95867 9.23715 10.3194C9.59786 10.6543 9.77821 11.0666 9.77821 11.5561C9.77821 12.0456 9.59786 12.4708 9.23715 12.8315C8.9022 13.1664 8.48997 13.3339 8.00043 13.3339C7.5109 13.3339 7.08578 13.1664 6.72507 12.8315C6.39013 12.4708 6.22266 12.0456 6.22266 11.5561C6.22266 11.0666 6.39013 10.6543 6.72507 10.3194C7.08578 9.95867 7.5109 9.77832 8.00043 9.77832Z",
    fill: "#EC6655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.93acfe549788ec79bf7e73356192b4d8.svg";
export { ForwardRef as ReactComponent };